// AdminSubnav.jsx — 三个 /admin/* 页共享的子页签条（第六十九批，需求方裁
// "管理页内共享子页签"）。
//
// ── 为什么是子页签而不是下拉或中转页 ────────────────────────────────────────
// 病灶：/admin/git 与 /admin/settings 只能手打地址——顶部导航只有一条"账号管理"
// 指向 /admin，另两页没有任何入口。需求方提了三个方案，裁定本形态，理由：
//   · 顶部导航仍是**一条**入口（appNav.mjs 的单一清单机制原样保留——第五十六批
//     "两份清单各自漂移 ⇒ 移动端五条入口全部失联"的教训，不给它加子菜单概念）；
//   · 无中转页（没有几乎空白的一页和来回跳）；
//   · 移动端 Tabs 自带横向滚动，不用另做一套。
//
// 清单只此一份。给管理面加第四页时**只改这里**——三个页面 map 同一个数组，
// 谁也不用记得去第二处补（与 appNav 同一条纪律）。
import { Tab, Tabs } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useT } from '../i18n/index.mjs';

export const ADMIN_SUBNAV = [
  { to: '/admin', key: 'admin.subnav.accounts' },
  { to: '/admin/git', key: 'admin.subnav.git' },
  { to: '/admin/api-keys', key: 'admin.subnav.apiKeys' },
  { to: '/admin/settings', key: 'admin.subnav.settings' },
  // 第八十一批：运行日志。它是这条页签条上**唯一不用来改配置的一页**，
  // 但它是出事那天唯一有人点开的一页——没有入口的观测面等于没有观测面。
  { to: '/admin/logs', key: 'admin.subnav.logs' },
  // 第八十六批：源码仓只读浏览。它与运行日志同族——**不用来改任何东西**，
  // 但"仓里到底有什么"这个问题此前只能靠 clone 才答得上来。
  { to: '/admin/repos', key: 'admin.subnav.repos' },
  // 第九十九批：工时燃耗对账（SB-104）。hourly 修正案把系统定为计费台账正本，
  // 「这周记了多少、离周额线多远」从此要在界面上答得出来。
  { to: '/admin/burn', key: 'admin.subnav.burn' },
  // 第一百一十批：agent 的逃生口报告（「我做不了」）。与运行日志同族——不改任何
  // 配置，但它是唯一能回答"这套系统交派任务的能力出了什么系统性问题"的一页。
  // 排在末位：它是低频但要紧的诊断面，而前面几页是日常入口。
  { to: '/admin/escalations', key: 'admin.subnav.escalations' },
  // SB-116（第一百二十一批）：敏感读面的读取记录。与运行日志/逃生口同族的诊断面
  // ——不改任何配置，但「这个资源谁读过」只有它答得出。排末位：取证是低频动作。
  { to: '/admin/read-audit', key: 'admin.subnav.readAudit' },
  // SB-190 §7.3（第二百四十六批）：响应时限（03-scoring D4 ①）的读面与裁决台。与逃生口
  // 同族的诊断面，但它还写：管理员在这里落裁决（追加式台账）。排末位：验收期才高频。
  { to: '/admin/response-sla', key: 'admin.subnav.responseSla' },
];

// 当前路由属于哪一签。按"最具体的命中"取：/admin/git 先被 /admin 前缀命中，
// 再被自己精确命中——数组顺序保证后者赢。
export function activeSubnav(pathname) {
  const p = String(pathname || '');
  let hit = '/admin';
  for (const e of ADMIN_SUBNAV) {
    if (p === e.to || p.startsWith(`${e.to}/`)) hit = e.to;
  }
  return hit;
}

export default function AdminSubnav() {
  const t = useT();
  const { pathname } = useLocation();
  return (
    <Tabs
      value={activeSubnav(pathname)}
      variant="scrollable"
      allowScrollButtonsMobile
      sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
    >
      {ADMIN_SUBNAV.map((e) => (
        <Tab key={e.to} value={e.to} label={t(e.key)} component={RouterLink} to={e.to} />
      ))}
    </Tabs>
  );
}
